export class AccountingBalanceSheetActiveModel {

  activo_No_Corriente: number;
  inmovilizado_Intangible: number;
  inmovilizado_Material: number;
  inversiones_Inmobiliarias: number;
  inversiones_En_Empresas_Del_Grupo_Y_Asociadas_A_Largo_Plazo: number;
  inversiones_Financieras_A_Largo_Plazo: number;
  activos_Por_Impuesto_Diferido: number;
  deudores_Comerciales_No_Corrientes: number;
  activo_Corriente: number;
  existencias: number;
  deudores_Comerciales_Y_Otras_Cuentas_A_Cobrar: number;
  clientes_Por_Ventas_Y_Prestaciones_De_Servicios: number;
  clientes_Por_Ventas_Y_Prestaciones_De_Servicios_A_Largo_Plazo: number;
  clientes_Por_Ventas_Y_Prestaciones_De_Servicios_A_Corto_Plazo: number;
  accionistas_Socios_Por_Desembolsos_Exigidos: number;
  otros_Deudores: number;
  inversiones_En_Empresas_Del_Grupo_Y_Asociadas_A_Corto_Plazo: number;
  inversiones_Financieras_A_Corto_Plazo: number;
  periodificaciones_A_Corto_Plazo: number;
  efectivo_Y_Otros_Activos_Liquidos_Equivalentes: number;
  total_Activo: number;

  constructor() {
  }

}
